module.exports = __webpack_public_path__ + "img/1581531513.07d55016.jpg";